<svg
  width="18"
  height="10"
  viewBox="0 0 18 10"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M12.7751 4.3125H2.57841H2.00001H1.50001H1.00001C1.00001 4.3125 0.457011 4.34766 0.281211 4.52344C0.10551 4.69922 1.04904e-05 4.91016 1.04904e-05 5.15625C1.04904e-05 5.40235 0.10551 5.61328 0.281211 5.78906C0.457011 5.96485 1.00001 6 1.00001 6C1.00001 6 1.15271 6 1.50001 6C1.66531 6 2.00001 6 2.00001 6H2.57841H12.7751C13.0696 6 13.1242 4.3125 12.7751 4.3125Z"
    fill="currentColor"
  />
  <line x1="7" y1="2" x2="12" y2="8.3" stroke="currentColor" stroke-width="1.5" />
</svg>
